import React from 'react';
import {
    Card, CardContent, CardActions, Box, Typography, Chip, Button, Tooltip,
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

/**
 * Card do catálogo de relatórios: ícone, título, descrição curta e "Abrir".
 *
 * Os filtros e os botões de exportação saíram daqui e foram para a página do
 * relatório. Com eles dentro, cada card tinha altura de formulário e o catálogo
 * virava uma pilha de três cards por tela — para escolher um relatório é
 * preciso ver vários ao mesmo tempo, não preencher datas em todos.
 *
 * Variante `comingSoon`: borda tracejada, sem ação, com Tooltip explicando.
 */
export default function ReportCard({
    icon, titulo, descricao, categoria,
    onAbrir,
    comingSoon = false,
}) {
    const card = (
        <Card
            variant="outlined"
            aria-disabled={comingSoon || undefined}
            sx={{
                width: '100%', height: '100%',
                display: 'flex', flexDirection: 'column',
                transition: 'border-color .15s, box-shadow .15s',
                ...(comingSoon
                    ? { borderStyle: 'dashed', opacity: 0.65 }
                    : {
                        '&:hover': {
                            borderColor: 'primary.main',
                            boxShadow: '0 2px 10px rgba(42,63,84,.10)',
                        },
                        // O foco do teclado tem de ser visível no card inteiro,
                        // não só no botão.
                        '&:focus-within': { borderColor: 'primary.main' },
                    }),
            }}
        >
            <CardContent sx={{ flexGrow: 1, p: 2, pb: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25, mb: 0.75 }}>
                    <Box sx={{ display: 'flex', mt: '2px' }}>{icon}</Box>
                    <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 600, lineHeight: 1.25, color: 'secondary.main' }}
                        >
                            {titulo}
                        </Typography>
                        {categoria && !comingSoon && (
                            <Typography variant="caption" color="text.secondary">{categoria}</Typography>
                        )}
                    </Box>
                    {comingSoon && <Chip label="Em breve" size="small" />}
                </Box>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ lineHeight: 1.45 }}
                >
                    {descricao}
                </Typography>
            </CardContent>

            <CardActions sx={{ mt: 'auto', px: 2, pb: 1.5, pt: 0 }}>
                <Button
                    size="small"
                    variant="text"
                    color="primary"
                    endIcon={<ArrowForwardIcon />}
                    disabled={comingSoon}
                    onClick={comingSoon ? undefined : onAbrir}
                    aria-label={`Abrir relatório de ${titulo}`}
                    sx={{ px: 1 }}
                >
                    Abrir relatório
                </Button>
            </CardActions>
        </Card>
    );

    if (comingSoon) {
        return (
            <Tooltip title="Recurso em desenvolvimento — disponível em breve" arrow>
                {/* Box garante tooltip sobre área aria-disabled */}
                <Box sx={{ width: '100%', height: '100%', display: 'flex' }}>{card}</Box>
            </Tooltip>
        );
    }
    return card;
}
